/**
 * 判断是否对象
 * @param {any} obj 被判断的元素
 * @returns {boolean} 是否是对象
 */
export function isObject(obj: any): boolean {
    if (obj === undefined || obj === null) {
        return false;
    }

    return Array.prototype.toString.call(obj) === '[object Object]';
}

export function isString(obj: any): boolean {
    return typeof obj === 'string';
}
